
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Cliente } from '@/__env/lib/Clientes';
    import { PresetImportarExcel } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.nav';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import editar from './lista-buscador-presets-editar.vue';
    import { IColumna } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.lib';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Tipos as TiposPedido } from '@/__env/lib/Ventas/Pedidos/Pedido.types';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import observaciones from './barra-lateral-observaciones.vue';
    import totales from './barra-lateral-totales.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            totales,
            observaciones,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Pedido() { return this.Controlador.Pedido; }

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto )
            {

            }
        }

        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Pedido.ComprobarFacturacion();
        }


        Cerrar()
        {
            this.Abierto = false;
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
